module.exports = __webpack_public_path__ + "fonts/Lato-Light.09201a1c.woff2";